import { Navbar } from "flowbite-react";
import React, { useContext } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../../assets/logo.png";
import { authContext } from "../Context/Context";

const Header = () => {
  const { user, logOut } = useContext(authContext);

    const handleDarkMode = () => {
      if (
        localStorage.theme === "dark" ||
        (!("theme" in localStorage) &&
          window.matchMedia("(prefers-color-scheme: dark)").matches)
      ) {
        document.documentElement.classList.remove("light");
        document.documentElement.classList.add("dark");
      } else {
        document.documentElement.classList.remove("light");
        document.documentElement.classList.add("dark");
      }
    };
    const handleLightMode = () => {
      if (
        localStorage.theme === "dark" ||
        (!("theme" in localStorage) &&
          window.matchMedia("(prefers-color-scheme: dark)").matches)
      ) {
        document.documentElement.classList.remove("dark");
        document.documentElement.classList.add("light");
      } else {
        document.documentElement.classList.remove("dark");
        document.documentElement.classList.add("light");
      }
    };

  return (
    <Navbar fluid={true} rounded={true}>
      <Navbar.Brand href="/">
        <img src={logo} className=" h-6 sm:h-9" alt="Flowbite Logo" />
        <span className="self-center text-green-600 whitespace-nowrap text-3xl font-bold dark:text-white">
          Mind Talking
        </span>
      </Navbar.Brand>
      <div className="lg:flex md:order-2  ">
        <Link to={"/appointments"}>
          <button
            type="button"
            className="text-white hidden lg:block bg-gradient-to-r from-green-400 via-green-500 to-green-600 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-green-300 dark:focus:ring-green-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 mb-2"
          >
            Appointment
          </button>
        </Link>
        <Navbar.Toggle />
        <label className="swap swap-rotate">
          <input className="invisible" type="checkbox" />

          <svg
            className="swap-on fill-current w-10 h-10 text-white"
            onClick={handleDarkMode}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" />
          </svg>

          <svg
            className="swap-off fill-current w-10 h-10"
            onClick={handleLightMode}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
          >
            <path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" />
          </svg>
        </label>
      </div>
      <Navbar.Collapse>
        <NavLink to={"/"}>
          <Navbar.Link className="hover:underline text-xl dark:text-white">
            Home
          </Navbar.Link>
        </NavLink>
        <NavLink to={"/services"}>
          <Navbar.Link className="hover:underline text-xl dark:text-white">
            Services
          </Navbar.Link>
        </NavLink>
        {/* <NavLink to={"/blogs"}>
          <Navbar.Link className="hover:underline text-xl dark:text-white">
            Blogs
          </Navbar.Link>
        </NavLink> */}

        {user?.uid ? (
          <>
            <NavLink to={"/myreview"}>
              <Navbar.Link className="hover:underline text-xl dark:text-white">
                My Review
              </Navbar.Link>
            </NavLink>
            <NavLink to={"/dashboard"}>
              <Navbar.Link className="hover:underline text-xl dark:text-white">
                Dashboard
              </Navbar.Link>
            </NavLink>
            <NavLink onClick={logOut}>
              <Navbar.Link className="hover:underline text-xl dark:text-white">
                Log out
              </Navbar.Link>
            </NavLink>
          </>
        ) : (
          <>
            <NavLink to={"/login"}>
              <Navbar.Link className="hover:underline text-xl dark:text-white">
                Login
              </Navbar.Link>
            </NavLink>
            <NavLink to={"/signup"}>
              <Navbar.Link className="hover:underline text-xl dark:text-white">
                Register
              </Navbar.Link>
            </NavLink>
          </>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
